import { render, staticRenderFns } from "./ProjectMemberOne.vue?vue&type=template&id=5a2c4156&"
import script from "./ProjectMemberOne.vue?vue&type=script&lang=ts&"
export * from "./ProjectMemberOne.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports